import { Select, Form, Button, message, Divider, Table, Popover } from 'antd';
import React, { useEffect, useState, useContext } from 'react';
import {
  getTeachers,
  bindSubjectsToTeacher,
  getTeacherSubjectsById,
  getInstitutionSubjectsById,
  unbindSubjectsToTeacher,
} from '../../../actions';
import { Context } from '../../../defaults';
import { Icon } from 'semantic-ui-react';

function SubjectsToTeacher() {
  const [teachers, setTeachers] = useState();
  const [subjects, setSubjects] = useState({ subjects: [], teacherSubjects: [] });
  const [bind, setBind] = useState({ teacherId: null, showTable: false, currentTeacher: null });
  const [form] = Form.useForm();
  const { dictionary, language, setLoading } = useContext(Context);

  const columns = [
    {
      title: `№`,
      dataIndex: 'number',
      key: 'number',
      fixed: 'left',
      render: (text, record, index) => index + 1,
    },
    {
      title: `${dictionary?.SubjectsName[language]}`,
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
    },
    {
      title: `${dictionary?.Action[language]}`,
      key: 'action',
      width: 100,
      fixed: 'right',
      render: (text, record, index) => (
        <Icon
          name="cancel"
          onClick={() => {
            onUnbindTeachers(record.id);
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    getTeachers().then(({ data }) => setTeachers(data));
  }, []);

  function fetchTeacherData(teacher) {
    return getTeacherSubjectsById(form.getFieldValue('teacherId')).then(({ data }) => {
      const tSubject = data.map((tS) => {
        return tS.subjectId;
      });
      getInstitutionSubjectsById(teacher.institutionId).then(({ data }) => {
        setSubjects({
          subjects: data.filter((s) => !tSubject.includes(s.id)),
          teacherSubjects: data.filter((s) => tSubject.includes(s.id)),
        });
      });
    });
  }

  const onUnbindTeachers = (subjectId) => {
    setLoading(true);
    unbindSubjectsToTeacher({ teacherId: bind.currentTeacher.id, subjectId: subjectId })
      .then(() => {
        setLoading(false);
        message.success(dictionary?.SuccessfullyDeleted[language], 4);
        fetchTeacherData(bind.currentTeacher);
      })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], 4);
        setLoading(false);
      });
  };

  const onBindTeachers = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        bindSubjectsToTeacher(values)
          .then(() => {
            setLoading(false);
            message.success(dictionary?.SuccessfullyAdded[language], 4);
            fetchTeacherData(bind.currentTeacher);
            form.setFieldsValue({ subjectIdList: [] });
          })
          .catch(() => {
            message.error(dictionary?.SomethingWentWrong[language], 4);
            setLoading(false);
          });
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  };

  const setLayout = (name) => {
    if (name === 'teacherId') {
      return { wrapperCol: { span: 14 } };
    } else {
      return { wrapperCol: { span: 13 } };
    }
  };

  return (
    <React.Fragment>
      <h1> Привязка предметов к учителю</h1>
      <Form form={form}>
        <Form.Item
          {...setLayout('teacherId')}
          name="teacherId"
          label="Учитель"
          rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
          <Select
            allowClear
            showSearch
            onChange={(e, data) => {
              !!data &&
                setBind({
                  teacherId: data.value,
                  showTable: true,
                  currentTeacher: teachers.find((teacher) => teacher.id === data.value),
                });
              !!data && fetchTeacherData(teachers.find((teacher) => teacher.id === data.value));
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Выберите учителя">
            {teachers &&
              teachers.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {`${el.firstName} ${el.middleName} ${el.lastName}`}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          {...setLayout('subjectIdList')}
          name="subjectIdList"
          label="Список предметов"
          rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
          <Select
            disabled={!bind.teacherId}
            mode="multiple"
            showSearch={true}
            allowClear={true}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Выберите предметы">
            {subjects &&
              subjects.subjects.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={onBindTeachers}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
      {bind.showTable && (
        <>
          <Table columns={columns} dataSource={subjects.teacherSubjects}></Table>
        </>
      )}
    </React.Fragment>
  );
}

export default SubjectsToTeacher;
